import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './_styles_/Reset2FAPopup.css';
import ModalDialog from '../ModalDialog';
import { jwtDecodeWrapper } from '../../utils/authentication';
import { downloadQRImage, initiateDownloadQRImage, reset2FA } from '../../actions/twoFAResets';
import ReadonlyField from '../fields/ReadonlyField';
import { get2FAResets } from '../../reducers';
import InfoPanel from '../InfoPanel';
import i18n from '../../i18n';
import PasswordField from '../fields/PasswordField';

Reset2FAPopup.propTypes = {
    hideDialog: PropTypes.func.isRequired,
};

function Reset2FAPopup(props) {
    const {
        hideDialog,
    } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const twoFAResetState = useSelector(get2FAResets);
    const decodedToken = jwtDecodeWrapper(twoFAResetState.resetToken);
    const secret = decodedToken['2faSecret'];
    const [totpToken, totpTokenChangeHandler] = useState('');

    if (!twoFAResetState.downloadingQrImage && !twoFAResetState.qrImage) {
        dispatch(initiateDownloadQRImage());
        dispatch(downloadQRImage(twoFAResetState.resetToken));
    }

    const onSubmit = (event) => {
        dispatch(reset2FA(twoFAResetState.resetToken, totpToken));
        event.preventDefault();
    };

    return (
        <ModalDialog onCancel={hideDialog}>
            <div className="reset-2fa-popup-dialog">
                <h4>{t('reset-2fa.title')}</h4>
                <InfoPanel
                    message={i18n.t('reset-2fa.info-panel')}
                />
                <form className="reset-2fa" onSubmit={onSubmit}>
                    <div className="reset-2fa-input-row">
                        <img src={`data:image/jpeg;base64,${twoFAResetState.qrImage}`} alt="" />
                    </div>
                    <div className="reset-2fa-input-row">
                        <ReadonlyField
                            label={t('request-2fa-reset.secret')}
                            value={secret}
                            className="authentication--2fa-secret"
                        />
                    </div>
                    <div className="reset-2fa-input-row">
                        <PasswordField
                            label={t('twoFA.token')}
                            icon="info"
                            className="authentication--2fa-confirmation"
                            iconTooltip={t('twoFA.token-tooltip')}
                            inputId="confirmation-token"
                            onChange={totpTokenChangeHandler}
                            useDynamicWidth={false}
                            error={twoFAResetState.totpTokenInvalid === true ? t('request-2fa-reset.error.confirmation-totp-invalid') : null}
                        />
                    </div>
                    <div className="buttons">
                        <button className="button button-bordered reset-2fa-button" type="submit">{t('button.save')}</button>
                        <button className="button button-bordered back-button" type="button" onClick={hideDialog}>{t('button.cancel')}</button>
                    </div>
                </form>
            </div>
        </ModalDialog>
    );
}

export default Reset2FAPopup;
